import { useGoogleLogin } from '@react-oauth/google';
import { emailConfig } from '../../../../../config';
import { BaseAppCard } from './base-app-card';
import { ReactComponent as GmailIcon } from '../../../../../components/icons/gmail-bigger.svg';
import { ChannelAccountStatus } from '@zaplify/channel-accounts/shared';
import { useApps } from '../hooks/use-apps';
interface GmailAuthCardProps {
    account: ReturnType<typeof useApps>['accounts']['gmail'];
}

export const GmailAuthCard = ({ account }: GmailAuthCardProps) => {
    const handleConnect = useGoogleLogin({
        onSuccess: (tokenResponse) => {
            // Google's auth-code flow returns the code directly
            if (tokenResponse.code) {
                account.handleGmailAuth(tokenResponse.code);
            }
        },
        flow: 'auth-code',
        scope: emailConfig.google.scopes.join(' '),
        onError: (error) => console.error('Gmail login failed:', error),
    });

    return (
        <BaseAppCard
            title="Gmail"
            appId="gmail"
            bgColor="bg-red-50"
            icon={<GmailIcon className="h-6 w-6 object-contain" />}
            isConnected={account.isConnected}
            handleConnect={handleConnect}
            isActive={account.isConnected}
            isLoading={account.state.isLoading}
            connectButtonText={
                account.status === ChannelAccountStatus.NOT_AUTHENTICATED ? 'Reconnect Gmail' : 'Connect Gmail'
            }
            avatar={{
                avatarUrl: account.avatarUrl,
                handle: account.emailAddress,
            }}
        />
    );
};
